import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BC, BCM, MBC, SC, SCA, serverUrl, ST } from '../../Constant/Static/config';
import PopModal from '../../Constant/Custom/Models/PopModal';
import Loader from '../../Constant/Custom/Loader';

function Personal({ studentData, handleNext, gotoComment }) {

  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [onCancel, setOnCancel] = useState(() => () => { });
  const [changes, setChanges] = useState(new Set());

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const storedUser = studentData || {};

  const [communities, setCommunities] = useState(["OC", "BC", "BCM", "MBC", "SC", "SCA", "ST"]);

  const [formData, setFormData] = useState({
    appNo: storedUser?.APPLN_NO || '',
    appName: storedUser?.APPLICANT_NAME || '',
    email: storedUser?.EMAIL || '',
    phone: storedUser?.MOBILE || '',
    parentName: '',
    aadhar: '',
    gender: '',
    dob: '',
    citizenship: '',
    nativity: '',
    category: '',
    religion: '',
    community: '',
    caste: '',
  });

  const [originalUserDetail, setOriginalUserDetail] = useState({
    appNo: storedUser?.APPLN_NO || '',
    appName: storedUser?.APPLICANT_NAME || '',
    email: storedUser?.EMAIL || '',
    phone: storedUser?.MOBILE || '',
    parentName: '',
    aadhar: '',
    gender: '',
    dob: '',
    citizenship: '',
    nativity: '',
    category: '',
    religion: '',
    community: '',
    caste: '',
  });

  const [changedFields, setChangedFields] = useState({
    appNo: false,
    appName: false,
    email: false,
    phone: false,
    parentName: false,
    aadhar: false,
    gender: false,
    dob: false,
    citizenship: false,
    nativity: false,
    category: false,
    religion: false,
    community: false,
    caste: false,
  });
  const setDefaultForm = () => {
    setFormData({
      appNo: storedUser?.appno || '',
      appName: storedUser?.userName || '',
      email: storedUser?.email || '',
      phone: storedUser?.mobile || '',
      parentName: '',
      aadhar: '',
      gender: '',
      dob: '',
      citizenship: '',
      nativity: '',
      category: '',
      religion: '',
      community: '',
      caste: '',
    });
    setOriginalUserDetail({
      appNo: storedUser?.appno || '',
      appName: storedUser?.userName || '',
      email: storedUser?.email || '',
      phone: storedUser?.mobile || '',
      parentName: '',
      aadhar: '',
      gender: '',
      dob: '',
      citizenship: '',
      nativity: '',
      category: '',
      religion: '',
      community: '',
      caste: '',
    });
    setChangedFields({
      appNo: false,
      appName: false,
      email: false,
      phone: false,
      parentName: false,
      aadhar: false,
      gender: false,
      dob: false,
      citizenship: false,
      nativity: false,
      category: false,
      religion: false,
      community: false,
      caste: false,
    });
  }

  const [csrfToken, setCsrfToken] = useState('');
  const [errors, setErrors] = useState({});

  const changedFieldsMap = {
    appName: "Applicant Name",
    parentName: "Parent Name",
    gender: "Gender",
    aadhar: "Aadhar",
    dob: "Date of birth",
    citizenship: "Citizenship",
    nativity: "Nativity",
    category: "Category",
    religion: "Religion",
    community: "Community",
    caste: "Caste"
  }

  const validateField = (name, value) => {
    let errorMessage = '';

    if (name === 'appName' && !(/^[a-zA-Z][a-zA-Z\s@()]{3,}$/).test(value.trim())) {
      errorMessage = 'Invalid Name.';
    }
    if (name === 'parentName' && !(/^[a-zA-Z][a-zA-Z\s@()]{3,}$/).test(value.trim())) {
      errorMessage = 'Invalid Name.';
    }
    if (name === 'gender' && value.trim() === "") {
      errorMessage = 'Please select Gender';
    }

     if (name === "aadhar") {
      const aadhaar = value.replace(/\s/g, "");
      if (formData.citizenship === "Indian") {
        if (aadhaar.trim() === "") {
          errorMessage = "Aadhaar Number is required";
        }
        else if (!/^\d{12}$/.test(aadhaar)) {
          errorMessage = "Enter a valid 12-digit Aadhaar Number";
        }
      }
    }
    
    if (name === "dob") {
      if (value === "") {
        errorMessage = "Please Enter Your Date of Birth";
      } else {
        const enteredDate = new Date(value);
        const today = new Date();
        const fifteenYearsAgo = new Date();
        const minDOB = new Date();
        minDOB.setFullYear(today.getFullYear() - 65);
        fifteenYearsAgo.setFullYear(today.getFullYear() - 15);

        if (enteredDate > fifteenYearsAgo || enteredDate < minDOB) {
          errorMessage = "Date of birth is invalid.";
        }
      }
    } else if (name === "dob" && new Date(value) > new Date()) {
      errorMessage = "Date of birth cannot be in the future.";
    }
    if (name === 'citizenship' && value.trim() === "") {
      errorMessage = 'Please select Citizenship';
    }
    if (name === 'nativity' && value.trim() === "") {
      errorMessage = 'Please select Nativity';
    }
    if (name === 'category' && value.trim() === "") {
      errorMessage = 'Please select Category';
    }
    if (name === 'religion' && value.trim() === "") {
      errorMessage = 'Please select Religion';
    }
    if (name === 'community' && value.trim() === "") {
      errorMessage = 'Please select community';
    }
    if (name === 'caste' && value.trim() === "") {
      errorMessage = 'Please select caste';
    }

    return errorMessage;
  };

  const setNestedValue = (object, path, value) => {
    const keys = path.split('.');
    let tempObj = object;
    keys.slice(0, -1).forEach((key) => {
      if (!tempObj[key]) tempObj[key] = {};
      tempObj = tempObj[key];
    });
    tempObj[keys[keys.length - 1]] = value;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;


    let error = validateField(name, value);
    let isChanged = value !== originalUserDetail[name];



    setFormData((prev) => {
      const updatedFormData = { ...prev };
      if (name.includes('.')) {
        setNestedValue(updatedFormData, name, value);
      } else {
        if (name === "nativity") updatedFormData["religion"] = ''
        if (name === "religion") updatedFormData["community"] = ''
        if (name === "community") updatedFormData["caste"] = '';
        updatedFormData[name] = value;
      }
      if (name === 'citizenship' && value === 'Others') {
        updatedFormData['aadhar'] = '';
        updatedFormData['nativity'] = '';
      }

      return updatedFormData;
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (name.includes('.')) {
        setNestedValue(updatedErrors, name, error);
      } else {
        updatedErrors[name] = error;
      }
      return updatedErrors;
    });

    setChangedFields((prevChangedFields) => {
      const updatedChangedFields = { ...prevChangedFields };
      if (name.includes('.')) {
        setNestedValue(updatedChangedFields, name, isChanged);
      } else {
        updatedChangedFields[name] = isChanged;
      }
      return updatedChangedFields;
    });

    const inputElement = document.querySelector(`[name=${name}]`);
    if (inputElement) {
      // console.log(`Input field changed: ${name}`);
      if (isChanged) {
        inputElement.classList.add('changed-field');
        setChanges((prev) => (
          new Set([...prev, changedFieldsMap[name]])
        ))
      } else {
        inputElement.classList.remove('changed-field');
        setChanges((prev) => new Set([...prev].filter(item => item !== changedFieldsMap[name])));
      }
    }


    if (name === "appName") {
      // const trimmedValue = value.trim();
      const upperValue = value.toUpperCase();
      // isValid = formData.name.isValid;
      // console.log(upperValue);

      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: upperValue,
      }));
      // return;
    }

  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const value = formData[key];
      if (typeof value === 'object') {
        // For nested fields (e.g., address)
        Object.keys(value).forEach((nestedKey) => {
          const nestedValue = value[nestedKey];
          const error = validateField(`${key}.${nestedKey}`, nestedValue);
          if (error) {
            isValid = false;
            setNestedValue(newErrors, `${key}.${nestedKey}`, error);
          }
        });
      } else {
        const error = validateField(key, value);
        if (error) {
          isValid = false;
          newErrors[key] = error;
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const submitPersonalDetails = async () => {
    setShowCancelButton(false)
    // console.log(changes);
    let changesToSend = [...changes];
    try {
      const response = await axios.post(`${serverUrl}/api/cv/student/personal-update`, { formData, changesToSend }, {
        headers: {
          'CSRF-Token': csrfToken
        },
        withCredentials: true
      });
      // console.log(response);
      if (response.status === 200) {
        setModalType({
          icon: 'success',
          title: 'Success',
          text: 'Personal Details are saved.',
        });
        openModal();
        setOnConfirm(() => handleNext);
      } else {
        // console.log(response);
      }
    } catch (err) {
      console.error('Failed to store data', err);
    }
  }

  const handlePersonalDetailSubmit = async () => {

    setShowCancelButton(false)
    if (formData.nativity === 'TamilNadu') {
      delete formData['category'];
    }
    if (!validateForm()) {
      setModalType({
        icon: 'warning',
        title: 'Warning',
        text: 'Please Fill All the Required Details',
      });
      openModal();
      setOnConfirm(() => closeModal);
      // console.log('Form is not valid');
      return;
    } else {
      let confirmationText = changes.size > 0 ? `Changed Fields :  ${[...changes].join(' | ')}` : 'No fields are changed';
      setModalType({
        title: 'Confirmation',
        icon: 'info',
        text: confirmationText
      })
      setShowCancelButton(true);
      setOnCancel(() => closeModal);
      setOnConfirm(() => submitPersonalDetails);
      openModal();
    }
  };


  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true  // Ensure cookies are sent
        });
        setCsrfToken(response.data.csrfToken);  // Set CSRF token
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      if (csrfToken) {
        try {
          const userData = studentData;
          if (userData) {
            const response = await axios.post(
              `${serverUrl}/api/cv/student/personal-load`,
              {
                appno: userData.APPLN_NO,
                email: userData.EMAIL,
                mobile: userData.MOBILE
              },
              {
                headers: {
                  'CSRF-Token': csrfToken  // Use CSRF token
                },
                withCredentials: true
              }
            );
            // console.log("Personal Info Response:", response.data);
            if (response.data.houseAddress === "") {
              setDefaultForm();
            } else {
              await setDefaultForm();
              setFormData(response.data);
              setOriginalUserDetail(response.data); // Set user data
            }
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchUserData();
  }, [csrfToken, studentData]);

  useEffect(() => {
    setDefaultForm();
  }, [csrfToken]);

  useEffect(() => {
    const handleCommunityChange = () => {
      let newCommunities = ["OC"];
      if (formData.nativity !== "Others") {
        if (formData.religion === "M") {
          newCommunities.push("BCM");
        } else if (formData.religion === "C" || formData.religion === "H") {
          newCommunities.push("BC");
          newCommunities.push("MBC");
          newCommunities.push("SC");
          newCommunities.push("SCA");
          newCommunities.push("ST");
        } else if (
          // formData.religion === "H" ||
          // formData.religion === "O" ||
          formData.nativity === "TamilNadu"
        ) {
          newCommunities.push("BC");
          newCommunities.push("BCM");
          newCommunities.push("MBC");
          newCommunities.push("SC");
          newCommunities.push("SCA");
          newCommunities.push("ST");
        }
      }

      setCommunities(newCommunities);
    };
    handleCommunityChange();
  }, [formData.nativity, formData.religion]);

  if (loading) {
    return <Loader />;
  }

  return (
    <section>
      <div className='section-head-container'>
        <h2 className='section-title'>Personal Information</h2>
        {/* <button className='log-btn button-primary' onClick={handleNext}>Save & Next</button> */}
      </div>
      <div className="form-group">
        <div>
          <div className="form-item">
            <label>
              Name of the Applicant
            </label>
            <span>(விண்ணப்பதாரரின் பெயர்)</span>
            <input
              style={{
                border: changedFields.appName
                  ? '1px solid rgb(18, 83, 162)'
                  : 'transparent',
                boxShadow: changedFields.appName
                  ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                  : '',
              }}
              type="text" name="appName" placeholder='Name of the Applicant' value={formData.appName} onChange={handleChange} />
            {errors.name && <span className='form-item-incorrect'>{errors.name}</span>}
          </div>
          <div className="form-item">
            <label>
              Email
            </label>
            <span>(மின்னஞ்சல் முகவரி)</span>
            <input type="email" name="email" placeholder='Enter Email' value={formData.email} onChange={handleChange} disabled />
          </div>
          <div className="form-item">
            <label>
              Contact Number
            </label>
            <span>(கைப்பேசி எண்)</span>
            <input type="text" name="phone" placeholder='Enter Contact Number' value={formData.phone} onChange={handleChange} disabled />
          </div>
          <div className="form-item">
            <label>
              Name of Parent/Guardian
            </label>
            <span>(பெற்றோர் / காப்பாளர் பெயர்)</span>
            <input style={{
              border: changedFields.parentName
                ? '1px solid rgb(18, 83, 162)'
                : 'transparent',
              boxShadow: changedFields.parentName
                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                : '',
            }} type="text" name="parentName" placeholder='Enter Name of Parent/Guardian' value={formData.parentName} onChange={handleChange} required />
            {errors.parentName && <span className='form-item-incorrect'>{errors.parentName}</span>}
          </div>
          <div className="form-item">
            <label>
              Gender
            </label>
            <span>(பாலினம்)</span>
            <select name="gender" value={formData.gender} onChange={handleChange}
              style={{
                border: changedFields.gender
                  ? '1px solid rgb(18, 83, 162)'
                  : 'transparent',
                boxShadow: changedFields.gender
                  ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                  : '',
              }} required>
              <option value=""> --- Select Gender --- </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
            {errors.gender && <span className='form-item-incorrect'>{errors.gender}</span>}
          </div>
          <div className="form-item">
            <label>
              Date of Birth
            </label>
            <span>(பிறந்த தேதி)</span>
            <input type="date" name="dob" value={formData.dob} onChange={handleChange}
              style={{
                border: changedFields.dob
                  ? '1px solid rgb(18, 83, 162)'
                  : 'transparent',
                boxShadow: changedFields.dob
                  ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                  : '',
              }} required />
            {errors.dob && <span className='form-item-incorrect'>{errors.dob}</span>}
          </div>
        </div>
        <div>
          <div className="form-item">
            <label>
              Citizenship
            </label>
            <span>(குடியுரிமை)</span>
            <select name="citizenship" value={formData.citizenship} onChange={handleChange}
              style={{
                border: changedFields.citizenship
                  ? '1px solid rgb(18, 83, 162)'
                  : 'transparent',
                boxShadow: changedFields.citizenship
                  ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                  : '',
              }} required>
              <option value=""> --- Select Citizenship --- </option>
              <option value="Indian">Indian</option>
              <option value="Others">Others</option>
            </select>
            {errors.citizenship && <span className='form-item-incorrect'>{errors.citizenship}</span>}
          </div>
          {formData.citizenship === "Indian" && (
            <div className="form-item">
              <label>
                Aadhaar Number
              </label>
              <span>(ஆதார் எண்)</span>

              <input
                style={{
                  border: changedFields.aadhar
                    ? '1px solid rgb(18, 83, 162)'
                    : 'transparent',
                  boxShadow: changedFields.aadhar
                    ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                    : '',
                }}
                type="text"
                name="aadhar"
                placeholder="Enter Aadhaar Number"
                value={(formData.aadhar || "")
                  .replace(/\s/g, "")
                  .replace(/(\d{4})(?=\d)/g, "$1 ")
                  .trim()}
                maxLength={14}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/\D/g, "").slice(0,12);

                  handleChange({
                    target: {
                      name: "aadhar",
                      value: rawValue,
                    },
                  });
                }}
              />

              {errors.aadhar && (
                <span className="form-item-incorrect">
                  {errors.aadhar}
                </span>
              )}
            </div>
          )}
          <div className="form-item">
            <label>
              Nativity
            </label>
            <span>(பிறப்பிடம்)</span>
            <select name="nativity" value={formData.nativity} onChange={handleChange}
              style={{
                border: changedFields.nativity
                  ? '1px solid rgb(18, 83, 162)'
                  : 'transparent',
                boxShadow: changedFields.nativity
                  ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                  : '',
              }} required >
              <option value=""> --- Select Nativity --- </option>
              {formData.citizenship === "Indian" && <option value="TamilNadu">Tamil Nadu</option>}

              <option value="Others">Others</option>
            </select>
            {errors.nativity && <span className='form-item-incorrect'>{errors.nativity}</span>}
          </div>
          {formData.nativity === "Others" && (
            <div className="form-item">
              <label>
                Category
              </label>
              <span>(வகை)</span>
              <select name="category" value={formData.category} onChange={handleChange}
                style={{
                  border: changedFields.category
                    ? '1px solid rgb(18, 83, 162)'
                    : 'transparent',
                  boxShadow: changedFields.category
                    ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                    : '',
                }} required>
                <option value=""> --- Select Category --- </option>
                <option value="1">Continuously Studied Past five years in Tamilnadu</option>
                <option value="2">My parent is Central Government/ State Government/Public sector Employee for Past five years continuously in Tamilnadu</option>
                <option value="3">My parent is serving as All India Tamilnadu Cadre officer</option>
              </select>
              {errors.category && <span className='form-item-incorrect'>{errors.category}</span>}
            </div>
          )}
          <div className="form-item">
            <label>
              Religion
            </label>
            <span>(மதம்)</span>
            <select name="religion" value={formData.religion} onChange={handleChange}
              style={{
                border: changedFields.religion
                  ? '1px solid rgb(18, 83, 162)'
                  : 'transparent',
                boxShadow: changedFields.religion
                  ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                  : '',
              }} required>
              <option value=""> --- Select Religion --- </option>
              <option value="H">Hindu</option>
              <option value="M">Muslim</option>
              <option value="C">Christian</option>
            </select>
            {errors.religion && <span className='form-item-incorrect'>{errors.religion}</span>}
          </div>
          <div className="form-item">
            <label>
              Community
            </label>
            <span>(சாதி)</span>
            <select name="community" value={formData.community} onChange={handleChange}
              style={{
                border: changedFields.community
                  ? '1px solid rgb(18, 83, 162)'
                  : 'transparent',
                boxShadow: changedFields.community
                  ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                  : '',
              }} required>
              <option value=""> --- Select Community --- </option>
              {communities.map((community) => (
                <option value={community}>{community}</option>
              ))}
              {/* <option value="OC">OC</option>
              <option value="BC">BC</option>
              <option value="MBC">MBC</option>
              <option value="BCM">BCM</option>
              <option value="SC">SC</option>
              <option value="SCA">SCA</option>
              <option value="ST">ST</option> */}
            </select>
            {errors.community && <span className='form-item-incorrect'>{errors.community}</span>}
          </div>
          <div className="form-item">
            <label>
              Caste
            </label>
            <span>(சாதிப்பெயர்)</span>
            <select name="caste" value={formData.caste} onChange={handleChange}
              style={{
                border: changedFields.caste
                  ? '1px solid rgb(18, 83, 162)'
                  : 'transparent',
                boxShadow: changedFields.caste
                  ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                  : '',
              }} required>
              <option value=""> --- Select Caste --- </option>

              {formData.community === "BC" &&
                BC.map(item => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "MBC" &&
                MBC.map(item => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "BCM" &&
                BCM.map(item => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "SC" &&
                SC.map(item => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "SCA" &&
                SCA.map(item => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "ST" &&
                ST.map(item => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "OC" && <option value="other">Other</option>}
            </select>
            {errors.caste && <span className='form-item-incorrect'>{errors.caste}</span>}
          </div>
        </div>
      </div>
      <br />
      <div className='next-button'>
        <input type='submit' className='button button-primary' onClick={handlePersonalDetailSubmit} value='Save & Next' />
        <input type='submit' className='button button-primary' style={{ backgroundColor: '#218838' }} onClick={gotoComment} value='Go to Comment' />
      </div>
      <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          showCancelButton={showCancelButton}
          cancelButtonText="Cancel"
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </div>
    </section>
  )
}

export default Personal;